import React from 'react';

export function DashboardLoadingSkeleton() {
  return (
    <div className="space-y-5 animate-pulse">
      <div className="flex items-center justify-between">
        <div className="space-y-2">
          <div className="h-6 w-56 rounded bg-slate-200" />
          <div className="h-3 w-72 rounded bg-slate-200" />
        </div>
        <div className="h-9 w-48 rounded-lg bg-slate-200" />
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {[0, 1, 2].map((i) => (
          <div key={i} className="h-28 rounded-xl border border-app-border bg-app-surface" />
        ))}
      </div>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-[1.6fr_1fr]">
        <div className="h-[340px] rounded-xl border border-app-border bg-app-surface" />
        <div className="h-[340px] rounded-xl border border-app-border bg-app-surface" />
      </div>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-[1.6fr_1fr]">
        <div className="h-64 rounded-xl border border-app-border bg-app-surface" />
        <div className="h-64 rounded-xl border border-app-border bg-app-surface" />
      </div>
    </div>
  );
}
